import { Badge } from '../components/ui/badge';
import { getStatusDisplay } from '../lib/utils';

export const StatusBadge = ({ status, size = 'default', className = '' }) => {
  const display = getStatusDisplay(status);
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';

  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid={`status-badge-${status}`}>
      <Badge variant="outline" className={`${display.primaryColor} rounded-sm ${textSize}`}>
        {display.primary}
      </Badge>
      {display.sub && (
        <Badge variant="outline" className={`${display.subColor} rounded-sm ${textSize}`}>
          {display.sub}
        </Badge>
      )}
    </span>
  );
};
